// Matches the fenced code blocks rendered by clearText/highlight.js. Both
// fences must be on their own line, with an optional language after the opener.
const FENCED_CODE_BLOCK = /^[ \t]*```[ \t]*([^\s`\r\n]+)?[^\r\n]*\r?\n[\s\S]*?^[ \t]*```[ \t]*$/m;

export function containsMarkdownCode(text?: string | null): boolean {
  return Boolean(text && FENCED_CODE_BLOCK.test(text));
}
